import React from 'react';
import { websiteName } from '../../api/apiConstants';

const HelpItem9 = () => {
  return (
    <>
      <p className='p'>
        When you select the help and information page you can find infomation
        and help about this web app {websiteName}:
      </p>
    </>
  );
};

export default HelpItem9;
